/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsReferences,
    SharedserviceMelcoModelsReferencesFromJSON,
    SharedserviceMelcoModelsReferencesFromJSONTyped,
    SharedserviceMelcoModelsReferencesToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsColorCollectionReferences
 */
export interface SharedserviceMelcoModelsColorCollectionReferences {
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsReferences>}
     * @memberof SharedserviceMelcoModelsColorCollectionReferences
     */
    design_list?: Array<SharedserviceMelcoModelsReferences> | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsReferences>}
     * @memberof SharedserviceMelcoModelsColorCollectionReferences
     */
    custom_product_list?: Array<SharedserviceMelcoModelsReferences> | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsReferences>}
     * @memberof SharedserviceMelcoModelsColorCollectionReferences
     */
    mapping_list?: Array<SharedserviceMelcoModelsReferences> | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsReferences>}
     * @memberof SharedserviceMelcoModelsColorCollectionReferences
     */
    global_mapping_list?: Array<SharedserviceMelcoModelsReferences> | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsReferences>}
     * @memberof SharedserviceMelcoModelsColorCollectionReferences
     */
    format_list?: Array<SharedserviceMelcoModelsReferences> | null;
}

export function SharedserviceMelcoModelsColorCollectionReferencesFromJSON(json: any): SharedserviceMelcoModelsColorCollectionReferences {
    return SharedserviceMelcoModelsColorCollectionReferencesFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsColorCollectionReferencesFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsColorCollectionReferences {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'design_list': !exists(json, 'design_list') ? undefined : (json['design_list'] === null ? null : (json['design_list'] as Array<any>).map(SharedserviceMelcoModelsReferencesFromJSON)),
        'custom_product_list': !exists(json, 'custom_product_list') ? undefined : (json['custom_product_list'] === null ? null : (json['custom_product_list'] as Array<any>).map(SharedserviceMelcoModelsReferencesFromJSON)),
        'mapping_list': !exists(json, 'mapping_list') ? undefined : (json['mapping_list'] === null ? null : (json['mapping_list'] as Array<any>).map(SharedserviceMelcoModelsReferencesFromJSON)),
        'global_mapping_list': !exists(json, 'global_mapping_list') ? undefined : (json['global_mapping_list'] === null ? null : (json['global_mapping_list'] as Array<any>).map(SharedserviceMelcoModelsReferencesFromJSON)),
        'format_list': !exists(json, 'format_list') ? undefined : (json['format_list'] === null ? null : (json['format_list'] as Array<any>).map(SharedserviceMelcoModelsReferencesFromJSON)),
    };
}

export function SharedserviceMelcoModelsColorCollectionReferencesToJSON(value?: SharedserviceMelcoModelsColorCollectionReferences | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'design_list': value.design_list === undefined ? undefined : (value.design_list === null ? null : (value.design_list as Array<any>).map(SharedserviceMelcoModelsReferencesToJSON)),
        'custom_product_list': value.custom_product_list === undefined ? undefined : (value.custom_product_list === null ? null : (value.custom_product_list as Array<any>).map(SharedserviceMelcoModelsReferencesToJSON)),
        'mapping_list': value.mapping_list === undefined ? undefined : (value.mapping_list === null ? null : (value.mapping_list as Array<any>).map(SharedserviceMelcoModelsReferencesToJSON)),
        'global_mapping_list': value.global_mapping_list === undefined ? undefined : (value.global_mapping_list === null ? null : (value.global_mapping_list as Array<any>).map(SharedserviceMelcoModelsReferencesToJSON)),
        'format_list': value.format_list === undefined ? undefined : (value.format_list === null ? null : (value.format_list as Array<any>).map(SharedserviceMelcoModelsReferencesToJSON)),
    };
}


